
export const globals = {
  pageTitleSuffix: 'San Diego Campaign Finance Transparency Dashboard',
  siteName: `Follow the Money San Diego`,
  siteSubTitle: `The City's Campaign Finance Transparency Dashboard`,
  siteCaption: `See how local campaigns are financed so you can be informed before you vote.`,
  contributionsColor: '#3392ff',
  contributionsColorShades: ['#143a66', '#2466b3', '#3392ff', '#479dff', '#70b3ff', '#add3ff'],
  expendituresInSupportColor: '#289a58',
  expendituresInSupportAltColor: '#207b46',
  expendituresInSupportAlt2Color: '#53ae79',
  expendituresInOppositionColor: '#ff2c19',
  expendituresInOppositionAltColor: '#cc2314',
}
